import styled from 'styled-components';
export const StatusWrapper = styled.div `
  display: flex;
  align-items: center;
  height: 100%;
  width: 2rem;
  min-width: 2rem;
`;
const StyledCircle = styled.span `
  display: block;
  width: 0.5rem;
  height: 0.5rem;
  box-sizing: border-box;
  border-radius: 50%;
`;
export const StyledCircleDone = styled(StyledCircle) `
  ${({ disabled, theme }) => `border: 1px solid ${!disabled ? theme.colors.grey11 : theme.colors.grey09};`}
  ${({ disabled, theme }) => `background-color: ${!disabled ? theme.colors.grey11 : theme.colors.grey09};`}
`;
export const StyledCircleCurrent = styled(StyledCircle) `
  ${({ disabled, theme }) => `border: 1px solid ${!disabled ? theme.colors.grey15 : theme.colors.grey10};`}
  ${({ disabled, theme }) => `background-color: ${!disabled ? theme.colors.grey15 : theme.colors.grey10};`}
`;
export const StyledCircleNew = styled(StyledCircle) `
  ${({ disabled, theme }) => `border: 1px solid ${!disabled ? theme.colors.grey15 : theme.colors.grey10};`}
  background-color: ${({ theme }) => `rgba(${theme.colors.transparent15}, 0)`};
`;
export const StyledDash = styled.span `
  display: block;
  width: 0.25rem;
  height: 1px;
  ${({ disabled, theme }) => `background-color: ${!disabled ? theme.colors.grey11 : theme.colors.grey09};`}
`;
